module.exports = __webpack_public_path__ + "static/media/onboarding.bfa24f03.png";